import * as React from 'react'
import { datalayerHandler } from '../../../utils/datalayer'
import { useInView } from '../../../utils/hooks/hooks/useInView'
import { isUrlExternal, Link } from '../../../utils/links'
import { maybeToMailPlusLink } from '../../../utils/mailplus'
import { actualityLinkBlockClasses, courseLinkBlockClasses, linkBlockClasses } from '../../../utils/style'
import { getClassName } from '../../../utils/utils'
import { InviewProps, SVGIconProps } from './blocksState'

export type LinkBlock = {
  index: number
  title?: React.ReactNode
  intro?: string
  items: LinkBlockItem[]
  SVGIcon?: SVGIconProps
  inview?: InviewProps
  isCourseList?: boolean
  isActualityList?: boolean
}

export type LinkBlockItem = {
  url: string
  title: string
  text?: string
}

export type LinkBlockStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  headerClassName: string
  titleClassName: string
  introClassName: string
  contentClassName: string
  listClassName: string
  itemClassName: string
  linkClassName: string
  linkInnerClassName: string
  linkLabelClassName: string
  linkTextClassName: string
  linkIconClassName: string
  iconExternalId: string
  iconInternalId: string
}>

function getBlockClasses(props: LinkBlock) {
  if (props.isCourseList != undefined && props.isCourseList == true) {
    return courseLinkBlockClasses;
  } else if (props.isActualityList != undefined && props.isActualityList == true) {
    return actualityLinkBlockClasses;
  }
  return linkBlockClasses;
}

export function LinkBlockLayout(props: LinkBlock) {
  const blockClasses = getBlockClasses(props)
  const { inview, index, intro, items, SVGIcon, title } = props
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("LinkBlockLayout inView:", inview),
    !inview?.triggerOnce
  )
  const inviewClassName = getClassName(blockClasses, 'blockClassName', 'container') + ' ' + (inView ? getClassName(blockClasses, 'inviewClassName', 'inview') : '')
  return (
    <section key={`block-${index}`} id={`io-${index}`} ref={ref} className={inviewClassName}>
      <div className={getClassName(blockClasses, 'innerClassName', 'py-5')}>
        {(title || intro) && (
          <header className={getClassName(blockClasses, 'headerClassName', '')}>
            {title && (
              <h2
                className={getClassName(blockClasses, 'titleClassName', 'mb-3')}
                id={`${index}`}
              >
                {title}
              </h2>
            )}
            {intro && (
              <p className={getClassName(blockClasses, 'introClassName', '')}>
                {intro}
              </p>
            )}
          </header>
        )}

        {items && items.length > 0 && (
          <div className={getClassName(blockClasses, 'contentClassName', '')}>
            <ul
              className={getClassName(
                blockClasses,
                'listClassName',
                'list-unstyled mb-0 row'
              )}
            >
              {items.map(
                (item) =>
                  item.title && (
                    <li
                      key={`link-${index}-${item.title}`}
                      className={getClassName(
                        blockClasses,
                        'itemClassName',
                        'col-md-6'
                      )}
                    >
                      <Link
                        url={item.url}
                        title={item.title}
                        className={getClassName(
                          blockClasses,
                          'linkClassName',
                          'btn btn-link w-100 text-left border-bottom rounded-0 pl-0'
                        )}
                        onClick={() =>
                          datalayerHandler('linklist', item.title, 'linklist', {
                            link: maybeToMailPlusLink(item.url)
                          })
                        }
                      >
                        <div className={getClassName(
                          blockClasses,
                          'linkInnerClassName',
                          ''
                        )}>
                          {item.title && (
                            <p
                              className={getClassName(
                                blockClasses,
                                'linkLabelClassName',
                                'm-0'
                              )}
                            >
                              {item.title}
                            </p>
                          )}
                          {item.text && (
                            <p
                              className={getClassName(
                                blockClasses,
                                'linkTextClassName',
                                'small m-0'
                              )}
                            >
                              {item.text}
                            </p>
                          )}
                        </div>
                        {SVGIcon && (
                          <svg
                            className={getClassName(
                              blockClasses,
                              'linkIconClassName',
                              ''
                            )}
                            aria-hidden="true"
                            width={SVGIcon.width ? SVGIcon.width : '24px'}
                            height={SVGIcon.height ? SVGIcon.height : '24px'}
                          >
                            <use
                              xlinkHref={`${isUrlExternal(item.url)
                                  ? getClassName(
                                    blockClasses,
                                    'iconExternalId',
                                    '#icon--external'
                                  )
                                  : getClassName(
                                    blockClasses,
                                    'iconInternalId',
                                    '#icon--chevron-right-large'
                                  )
                                }`}
                            />
                          </svg>
                        )}
                      </Link>
                    </li>
                  )
              )}
            </ul>
          </div>
        )}
      </div>
    </section>
  )
}
